import { render, staticRenderFns } from "./setUp.vue?vue&type=template&id=7eda58e8&scoped=true&"
import script from "./setUp.vue?vue&type=script&lang=ts&"
export * from "./setUp.vue?vue&type=script&lang=ts&"
import style0 from "./setUp.vue?vue&type=style&index=0&id=7eda58e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eda58e8",
  null
  
)

export default component.exports